



























































import { Component, Vue } from "vue-property-decorator";
import userManager from "@/plumbing/auth";
import userStore from "@/store/userStore";
import { Observer } from "mobx-vue";
import mapStore from "@/store/mapStore";

@Observer
@Component
export default class Navbar extends Vue {
  userStore = userStore;
  mapStore = mapStore;

  links = [
    {
      to: "/",
      allowedRoles: null,
      text: "Home"
    },
    {
      to: "Reports",
      allowedRoles: ["Council Admin"],
      text: "Reports"
    },
    {
      to: "Requests",
      allowedRoles: ["Council Admin"],
      text: "Requests"
    },
    {
      to: "video-requests",
      allowedRoles: null,
      text: "Video Requests",
      filter: () => userStore.canAccessVideoRequests()
    },
    {
      to: "Admin",
      allowedRoles: ["Council Admin"],
      text: "Admin"
    }
  ];

  visibleLinks() {
    return this.links.filter(link => (!link.allowedRoles || link.allowedRoles.some(role => userStore.hasRole(role))) && (!link.filter || link.filter()));
  }

  async logout() {
    try {
      await userManager.signoutRedirect();
    } catch (error) {
      console.error(error);
      this.$router.push({ name: "Error" });
    }
  }

  get navbarClass() {
    return { "is-floating": this.$route.name === "Home" };
  }
}
